import { chain } from 'icepick';
import queryString from 'query-string';
import type { Location } from '@atlassian/jira-router';
import { QUERY_PARAM_SELECTED_ISSUE } from '../../../model/routing/constants';
import type { CardKey } from '../../../model/types';

export const addSelectedIssueToUrl = (cardKey: CardKey, location: Location) => {
	const search = chain({
		...queryString.parse(location.search),
	});

	search.set(QUERY_PARAM_SELECTED_ISSUE, cardKey);

	return {
		...location,
		search: queryString.stringify(search.value()),
	};
};

export const removeSelectedIssueFromUrl = (location: Location) => {
	const search = chain({
		...queryString.parse(location.search),
	});

	search.unset(QUERY_PARAM_SELECTED_ISSUE);

	return {
		...location,
		search: queryString.stringify(search.value()),
	};
};
